export default class ListingHelper {
  static groupListingsByAddressId(listings) {
    return listings.reduce((acc, listing) => {
      if (!listing.addressId) {
        return acc;
      }

      const group = (acc[listing.addressId] || []);
      group.push(listing);
      acc[listing.addressId] = group;

      return acc;
    }, {});
  }
}
